import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      // Bucket hosting serves the app at /index.html, Render serves it at /.
      // Match both rather than guessing from VITE_BASE_URL - a base that is set
      // but resolves to '/' picked the wrong one and left router-view empty.
      path: '/',
      alias: '/index.html',
      name: 'main',
      component: MainView,
    },
  ],
})

export default router
